<template>
    <div class="comButton">
        <!-- 组件已全局挂载 -->
        <button :class="['comButton_btn' , type ]" :disabled="disabled" @click="handleClick">
            <slot>{{btnText}}</slot>
        </button>
    </div>
</template>

<script>
export default {
    name: 'ComButton',
    props:{
        btnText:{
            type:String,
            default:'按钮'
        },
        type:{ // primary-普通颜色 default-置灰
            type:String,
            default:'primary'
        },
        disabled:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return {

        }
    },
    methods:{
        handleClick(){
            this.$emit('click')
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>